export const TOGGLE_SESSION_EXPIRED_MODAL = 'common/TokenExpiredModal/TOGGLE_SESSION_EXPIRED_MODAL';

export const toggleSessionExpiredModalActionCreator = value => ({
    type: TOGGLE_SESSION_EXPIRED_MODAL,
    payload: value,
});
